import { newContent } from '../../actions';
import { createReducer } from '@reduxjs/toolkit';

export default createReducer(false, (builder) =>
  builder.addCase(newContent, () => true),
);
